import React, { Component } from "react"
import { NavLink } from "react-router-dom"
import { famdyauth, famdydb } from '../../../service';
import swal from 'sweetalert';

export class FormTable extends Component {

    constructor(props) {
        super(props)
        this.state = {
            id: props.values.id,
            text: props.values.text,
            like: props.values.like,
            dislike: props.values.dislike,
            dare: props.dare,
            disabled: true
        }
        this.setDare=this.setDare.bind(this)
        this.removeDare=this.removeDare.bind(this)

    }

    componentDidUpdate(pP){
        if(pP.values !== this.props.values)
        {
            const {id, text, like, dislike} = this.props.values
            this.setState({id, text, like, dislike})
        }
    }

    setDare(){
        const {id, text, like, dislike, dare} = this.state
        famdydb.collection(dare).doc(id)
        .update({text: text})
        .then(function() {
            swal("Амжилттай нэмлээ!", "", "success");
        })
        .catch((error) => {
            swal("Алдаа!", error, "error");
        })
        this.setState({disabled: true})
    }

    removeDare(){
        const {id, text, like, dislike, dare} = this.state
        famdydb.collection(dare).doc(id)
        .delete()
        .then(() => {
            swal("Амжилттай устлаа!", "", "success");
            this.setState({disabled: true})
            this.props.getData()
        })
        .catch((error) => {
            swal("Алдаа!", error, "error");
            this.setState({disabled: true})
            this.props.getData()
        })
    }

    render() {
        const {id, text, like, dislike, dare, disabled} = this.state
        return (
            <tr className="odd">
                <td>{id}</td>
                <td>
                    <input
                        name="text"
                        type="text"
                        id="text"
                        disabled={disabled}
                        className='form-control'
                        onChange={(e) => this.setState({text: e.target.value})}
                        value = {text}
                    />
                </td>
                <td>{like}</td>
                <td>{dislike}</td>
                <td>
                    {disabled ?
                    <a role="button" className="text-success" onClick={() => this.setState({disabled: false})}>
                        <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                    </a>
                    :
                    <a role="button" className="text-success" onClick={this.setDare}>
                        <i className="fa fa-save" aria-hidden="true"></i>
                    </a>
                    }
                </td>
                <td>
                    <a role="button" className="text-danger" onClick={this.removeDare}>
                        <i className="fa fa-trash-o" aria-hidden="true"></i>
                    </a>
                </td>
            </tr>
        )

    }

}
